var render = function render(){var _vm=this,_c=_vm._self._c;return _c('station-list',{on:{"change-tab":_vm.handleChangeTab}})
}
var staticRenderFns = []

export { render, staticRenderFns }